import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';
import { RctCard, RctCardContent } from 'Components/RctCard';

import { 
  
 } from 'Actions';

import Fitness from './fitness';
import ScreningReport from '../../../sportsscience/studmskreport/index';
import MSKcompareReport from '../../../sportsscience/mskcomparativereport/index';
import SCcompareReport from '../../../sportsscience/sccomparativereport/index';
import FindingReport from '../../../sportsscience/studfindingreport/index';
import InjuryChartReport from '../../../sportsscience/studinjurychartreport/index';
import InjuryProfile from '../../../sportsscience/studinjuryprofilereport/index';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

class SSDashboard extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        
	}
    constructor(props) {
      
        super(props);        
        this.state = {  
            student:'', 
            startdate:'',
            enddate:'',
            loader:false,
            maindiv:true,
            fitness:false,
            psychology:false,
            nutrition:false,
            screningdiv:false,
            mskcompare:false,
            sccompare:false,
            findchart:false,
            injuryreport:false,
            injuryprofile:false,
        };

        this.onBackSection = this.onBackSection.bind(this);
        this.onSSselection = this.onSSselection.bind(this);
        this.onFitnessBack = this.onFitnessBack.bind(this);
    }

    rangeSelection(id){
        
       if(id==1){
            
                this.setState({ 
                    maindiv:false,
                    psychology:false,
                    nutrition:false,
                    fitness:true,
                });
        }else if(id==2){
           
                this.setState({ 
                    maindiv:false,
                    fitness:false,
                    nutrition:false,
                    psychology:true,
                });
        }else if(id==3){
           
                this.setState({ 
                    maindiv:false,
                    fitness:false,
                    psychology:false,
                    nutrition:true,
                });
        }
    }

    onBackSection() {
		this.setState({ 
            maindiv:true,
            fitness:false,
            psychology:false,
            nutrition:false,
        });
	}

    onFitnessBack() {
		this.setState({ 
            injuryprofile:false,
            injuryreport:false,
            findchart:false,
            sccompare:false,
            mskcompare:false,
            screningdiv:false,
            fitness:true,
        });
	}

    onSSselection(id){
        if(id==1){
            this.setState({ 
                fitness:false,
                screningdiv:true,
            });
        }else if(id==2){
            this.setState({ 
                fitness:false,
                mskcompare:true,
            });
        }else if(id==3){
            this.setState({ 
                fitness:false,
                sccompare:true,
            });
        }else if(id==4){
            this.setState({ 
                fitness:false,
                findchart:true,
            });
        }else if(id==5){
            this.setState({ 
                fitness:false,
                injuryreport:true,
            });
        }else if(id==6){
            this.setState({ 
                fitness:false,
                injuryprofile:true,
            });
        }

    }


render() {

    const { playerinterventionlist, loading} = this.props;   
    

      return(
        <div>   
                {this.state.maindiv && 
                <>
                <div className="row" style={{marginBottom:"20px"}}>
                    <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                    <div className="col-lg-8"><h2 className="text-center">SPORT SCIENCE DASHBOARD</h2></div>
                    <div className="col-lg-2"></div>
                </div>
                <div className="row">
                    
                     <div className="col-sm-12 col-lg-3">
                        <RctCard>
                            <a onClick={() =>this.rangeSelection(1)}>
                              <RctCardContent>
                                 <img src={require('Assets/img/dashboard/ss_inner.jpg')} className="img-fluid" alt="site-logo" />
                                 <button class="btn btn-warning btn-block">FITNESS</button>
                              </RctCardContent>
                            </a>  
                        </RctCard>      
                     </div> 
                     <div className="col-sm-12 col-lg-3">
                        <RctCard>
                            <a onClick={() =>this.rangeSelection(2)}>
                              <RctCardContent>
                                 <img src={require('Assets/img/dashboard/ss_inner3.png')} className="img-fluid" alt="site-logo" />
                                 <button class="btn btn-warning btn-block">PSYCHOLOGY</button>
                              </RctCardContent>
                            </a>  
                        </RctCard>      
                     </div> 
                     <div className="col-sm-12 col-lg-3">
                        <RctCard>
                            <a onClick={() =>this.rangeSelection(3)}>
                              <RctCardContent>
                                 <img src={require('Assets/img/dashboard/ss_inner2.png')} className="img-fluid" alt="site-logo" />
                                 <button class="btn btn-warning btn-block">NUTRITION</button>
                              </RctCardContent>
                            </a>  
                        </RctCard>      
                     </div>     
                    
                </div>  
                </> 
            } 
            {/* ======== Fitness report ================ */}
            {this.state.fitness &&
                <>
                    <div className="row" style={{marginBottom:"20px"}}>
                        <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                        <div className="col-lg-8"><h2 className="text-center">FITNESS REPORT</h2></div>
                        <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={this.onBackSection}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                    </div>
                    <Fitness onClick={this.onSSselection} />
                </>   
            }
            
            {this.state.screningdiv &&
                <>
                    <div className="row" style={{marginBottom:"20px"}}>
                        <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                        <div className="col-lg-8"><h2 className="text-center">SPORTS SCIENCE SCREENING REPORT</h2></div>
                        <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={this.onFitnessBack}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                    </div>
                <ScreningReport />
                </>
            }
            {this.state.mskcompare &&
                <>
                    <div className="row" style={{marginBottom:"20px"}}>
                        <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                        <div className="col-lg-8"><h2 className="text-center">MSK COMPARATIVE ANALYSIS REPORT</h2></div>
                        <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={this.onFitnessBack}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                    </div>
                <MSKcompareReport />
                </>
            }
            {this.state.sccompare &&
                <>
                    <div className="row" style={{marginBottom:"20px"}}>
                        <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                        <div className="col-lg-8"><h2 className="text-center">S&C COMPARATIVE ANALYSIS REPORT</h2></div>
                        <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={this.onFitnessBack}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                    </div>
                <SCcompareReport />
                </>
            }
            {this.state.findchart &&
                <>
                    <div className="row" style={{marginBottom:"20px"}}>
                        <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                        <div className="col-lg-8"><h2 className="text-center">MSK FINDINGS REPORT</h2></div>
                        <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={this.onFitnessBack}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                    </div>
                <FindingReport />
                </>
            }
            {this.state.injuryreport &&
                <>
                    <div className="row" style={{marginBottom:"20px"}}>
                        <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                        <div className="col-lg-8"><h2 className="text-center">INJURY REPORT & UPDATES</h2></div>
                        <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={this.onFitnessBack}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                    </div>
                <InjuryChartReport />
                </>
            }
            {this.state.injuryprofile &&
                <>
                    <div className="row" style={{marginBottom:"20px"}}>
                        <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                        <div className="col-lg-8"><h2 className="text-center">INJURY PROFILE</h2></div>
                        <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={this.onFitnessBack}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                    </div>
                <InjuryProfile />
                </>
            }
            {/* ======== psychology report ================ */}    
            {this.state.psychology &&
                <>
                    <div className="row" style={{marginBottom:"20px"}}>
                        <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                        <div className="col-lg-8"><h2 className="text-center">PSYCHOLOGY REPORT</h2></div>
                        <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={this.onBackSection}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                    </div>
                    
                </>   
            }

            {/* ======== NUTRITION report ================ */}    
            {this.state.nutrition &&
                <>
                    <div className="row" style={{marginBottom:"20px"}}>
                        <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                        <div className="col-lg-8"><h2 className="text-center">NUTRITION REPORT</h2></div>
                        <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={this.onBackSection}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                    </div>
                    
                </>   
            }

        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ playerintervention }) => {
    const { playerinterventionlist, loading } = playerintervention;
    return { playerinterventionlist, loading };
   
}


export default connect(mapStateToProps, {
    
})(SSDashboard);
